import { ReactNode } from 'react';
import { API } from '@shared/types/api';
import { ViewTemplateContext } from './context';

interface Props {
  template: API.ViewTemplateFragment | null;
  children: ReactNode;
}

export function BlockViewTemplateProvider({ template, children }: Props) {
  return <ViewTemplateContext.Provider value={template}>{children}</ViewTemplateContext.Provider>;
}
